const Astericsign = () => {
  return (
    <>
      <span className='text-danger'>*</span>
    </>
  )
}

export default Astericsign
